import { useSelector } from "react-redux";
import LinkButton from "../components/buttons/linkButton.component";
import { getRouterPaths } from "../router/routerPaths";
import { Box } from "@mui/material";

const NotFoundPage = () => {
  const userType = useSelector((state) => state.me?.data?.data?.type);
  const routerPaths = getRouterPaths(userType);
  return (
    <Box
      width="100%"
      height="100%"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <div style={{ textAlign: "center" }}>
        <h1>Pagina non trovata</h1>
        <p>Ci dispiace, questa pagina non esiste o è stata rimossa</p>
        <LinkButton label="Torna alla Home" href={routerPaths.home} />
      </div>
    </Box>
  );
};

export default NotFoundPage;
